/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import Footer from "./footer";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: "14px",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: 0,
    stt: "",
    asset: "TÀI SẢN",
    assetBold: true,
    assetCenter: true,
    sttBold: true,
    presentReadOnly: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: "", before: "" },
  },
  {
    id: 1,
    stt: "100",
    asset: "A. TÀI SẢN NGẮN HẠN (100=110+130)",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 2,
    stt: "110",
    asset: "I. Tài sản tài chính (110=111+112+...+129)",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 3,
    stt: "111",
    asset: "1. Tiền và các khoản tương đương tiền",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 4,
    stt: "111.1",
    asset: "1.1. Tiền ",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 5,
    stt: "111.2",
    asset: "1.2. Các khoản tương đương tiền ",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 6,
    stt: "112",
    asset: "2. Các tài sản chính nghi nhận thông qua lãi/lỗ (FVTPL) ",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 7,
    stt: "113",
    asset: "3. Các khoản đầu tư nắm giữ đến ngày đáo hạn (HTM)",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 8,
    stt: "114",
    asset: "4. Các khoản cho vay",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 9,
    stt: "115",
    asset: "5. Tài sản tài chính sẵn sàng để bán (AFS)",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 10,
    stt: "116",
    asset: "6. Dự phòng suy giảm giá trị các tài sản tài chính và tài sản thế chấp",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 11,
    stt: "117",
    asset: "7. Các khoản phải thu (117=117.1+117.2)",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 12,
    stt: "117.1",
    asset: "7.1. Phải thu bán các tài sản chính",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 13,
    stt: "117.2",
    asset: "7.2. Phải thu và dự thu cổ tức, tiền lãi các tài sản tài chính",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 14,
    stt: "117.3",
    asset: "7.2.1. Phải thu cổ tức, tiền lãi đến ngày nhận",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 15,
    stt: "117.4",
    asset: "7.2.2. Dự thu cổ tức, tiền lãi chưa đến ngày nhận",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 16,
    stt: "118",
    asset: "8. Trả trước cho người bán",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 17,
    stt: "119",
    asset: "9. Phải thu các dịch vụ CTCK cung cấp",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 18,
    stt: "120",
    asset: "10. Phải thu nội bộ",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 19,
    stt: "121",
    asset: "11. Phải thu về lỗi giao dịch chứng khoán",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 20,
    stt: "122",
    asset: "12. Các khoản phải thu khác",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 21,
    stt: "129",
    asset: "13. Dự phòng suy giảm giá trị các khoản phải thu (*)",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 22,
    stt: "130",
    asset: "II. Tài sản ngắn hạn khác",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 23,
    stt: "131",
    asset: "1. Tạm ứng",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 24,
    stt: "132",
    asset: "2. Vật tư văn phòng, công cụ, dụng cụ",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 25,
    stt: "133",
    asset: "3. Chi phí trả trước ngắn hạn",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 26,
    stt: "134",
    asset: "4. Cầm cố, thế chấp, ký quỹ, ký cược ngắn hạn",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 27,
    stt: "135",
    asset: "5. Thuế giá trị gia tăng được khấu trừ",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 28,
    stt: "136",
    asset: "6. Thuế và các khoản khác phải thu Nhà nước",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 29,
    stt: "137",
    asset: "7. Tài sản ngắn hạn khác",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 30,
    stt: "138",
    asset: "8. Giao dịch mua bán lại trái phiếu Chính phủ",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 31,
    stt: "139",
    asset: "9. Dự phòng suy giảm giá trị tài sản ngắn hạn khác",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 32,
    stt: "200",
    asset: "B. TÀI SẢN DÀI HẠN (200=210+220+230+240+250+260)",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 33,
    stt: "210",
    asset: "I. Tài sản tài chính dài hạn",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 34,
    stt: "211",
    asset: "1. Các tài sản phải thu dài hạn",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 35,
    stt: "212",
    asset: "2. Các khoản đầu tư",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 36,
    stt: "212.1",
    asset: "2.1. Các khoản đầu tư nắm giữ đến ngày đáo hạn",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 37,
    stt: "212.2",
    asset: "2.2. Đầu tư vào công ty con",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 38,
    stt: "212.3",
    asset: "2.3. Đầu tư vào công ty liên doanh, liên kết",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 39,
    stt: "212.4",
    asset: "2.4. Đầu tư dài hạn khác",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 40,
    stt: "213",
    asset: "3. Dự phòng suy giảm tài sản tài chính dài hạn",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 41,
    stt: "220",
    asset: "II. Tài sản cố định",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 42,
    stt: "221",
    asset: "1. Tài sản cố định hữu hình",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 43,
    stt: "222",
    asset: "- Nguyên giá",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 44,
    stt: "223a",
    asset: "- Giá trị hao mòn lũy kế (*)",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 45,
    stt: "223b",
    asset: "- Đánh giá TSCĐHH theo giá trị hợp lý",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 46,
    stt: "224",
    asset: "2. Tài sản cố định thuê tài chính",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 47,
    stt: "225",
    asset: "- Nguyên giá",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 48,
    stt: "226a",
    asset: "- Giá trị hao mòn lũy kế (*)",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 49,
    stt: "226b",
    asset: "- Đánh giá TSCĐTTC theo giá trị hợp lý",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 50,
    stt: "227",
    asset: "3. Tài sản cố định vô hình",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 51,
    stt: "228",
    asset: "- Nguyên giá",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 52,
    stt: "229a",
    asset: "- Giá trị hao mòn lũy kế (*)",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 53,
    stt: "229b",
    asset: "- Đánh giá TSCĐVH theo giá trị hợp lý",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 54,
    stt: "230",
    asset: "III. Bất động sản đầu tư",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 55,
    stt: "231",
    asset: "- Nguyên giá",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 56,
    stt: "232a",
    asset: "- Giá trị hao mòn lũy kế (*)",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 57,
    stt: "232b",
    asset: "- Đánh giá BĐSĐT theo giá trị hợp lý",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 58,
    stt: "240",
    asset: "IV. Chi phí xây dựng cơ bản dở dang",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 59,
    stt: "250",
    asset: "V. Tài sản dài hạn khác",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 60,
    stt: "251",
    asset: "1. Cầm cố, thế chấp, ký quỹ, ký cược dài hạn",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 61,
    stt: "252",
    asset: "2. Chi phí trả trước dài hạn",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 62,
    stt: "253",
    asset: "3. Tài sản thuế thu nhập hoãn lại",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 63,
    stt: "254",
    asset: "4. Tiền quỹ nộp Quỹ hỗ trợ thanh toán",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 64,
    stt: "255",
    asset: "5. Tài sản dài hạn khác",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 65,
    stt: "260",
    asset: "VI. Dự phòng suy giảm giá trị tài sản dài hạn",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 66,
    stt: "270",
    sttBold: true,
    asset: "TỔNG CỘNG TÀI SẢN (270=100+200)",
    assetCenter: true,
    assetBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 67,
    stt: "300",
    asset: "C. NỢ PHẢI TRẢ (300=310+340)",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 68,
    stt: "310",
    asset: "I. Nợ phải trả ngắn hạn",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 69,
    stt: "311",
    asset: "1. Vay và nợ thuê tài chính ngắn hạn",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 70,
    stt: "312",
    asset: "1.1. Vay ngắn hạn",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 71,
    stt: "313",
    asset: "1.2. Nợ thuê tài chính ngắn hạn",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 72,
    stt: "314",
    asset: "2. Vay tài sản tài chính ngắn hạn",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 73,
    stt: "315",
    asset: "3. Trái phiếu chuyển đổi ngắn hạn - Cấu phần nợ",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 74,
    stt: "316",
    asset: "4. Trái phiếu phát hành ngắn hạn",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 75,
    stt: "317",
    asset: "5. Vay Quỹ hỗ trợ thanh toán",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 76,
    stt: "318",
    asset: "6. Phải trả hoạt động giao dịch chứng khoán",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 77,
    stt: "319",
    asset: "7. Phải trả về lỗi giao dịch các tài sản chính",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 78,
    stt: "320",
    asset: "8. Phải trả người bán ngắn hạn",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 79,
    stt: "321",
    asset: "9. Người mua trả tiền trước ngắn hạn",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 80,
    stt: "322",
    asset: "10. Thuế và các khoản phải nộp Nhà nước",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 81,
    stt: "323",
    asset: "11. Phải trả người lao động",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 82,
    stt: "324",
    asset: "12. Các khoản trích nộp phúc lợi nhân viên",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 83,
    stt: "325",
    asset: "13. Chi phí phải trả ngắn hạn",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 84,
    stt: "326",
    asset: "14. Phải trả nội bộ ngắn hạn",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 85,
    stt: "327",
    asset: "15. Doanh thu chưa thực hiện ngắn hạn",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 86,
    stt: "328",
    asset: "16. Nhận ký quỹ, ký cược ngắn hạn",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 87,
    stt: "329",
    asset: "17. Các khoản phải trả, phải nộp khác ngắn hạn",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 88,
    stt: "330",
    asset: "18. Dự phòng phải trả ngắn hạn",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 89,
    stt: "331",
    asset: "19. Quỹ khen thưởng, phúc lợi",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 90,
    stt: "332",
    asset: "20. Giao dịch mua bán lại trái phiếu Chính phủ",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 91,
    stt: "340",
    asset: "II. Nợ phải trả dài hạn",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 92,
    stt: "341",
    asset: "1. Vay và nợ thuê tài chính dài hạn",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 93,
    stt: "342",
    asset: "1.1. Vay dài hạn",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 94,
    stt: "343",
    asset: "1.2. Nợ thuê tài chính dài hạn",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 95,
    stt: "344",
    asset: "2. Vay tài sản tài chính dài hạn",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 96,
    stt: "345",
    asset: "3. Trái phiếu chuyển đổi dài hạn - Cáu phần nợ",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 97,
    stt: "346",
    asset: "4. Trái phiếu phát hành dài hạn",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 98,
    stt: "347",
    asset: "5. Phải trả người bán dài hạn",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 99,
    stt: "348",
    asset: "6. Người mua trả tiền trước dài hạn",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 100,
    stt: "349",
    asset: "7. Chi phí phải trả dài hạn",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 101,
    stt: "350",
    asset: "8. Phải trả nội bộ dài hạn",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 102,
    stt: "351",
    asset: "9. Doanh thu chưa thực hiện dài hạn",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 103,
    stt: "352",
    asset: "10. Nhận ký quỹ, ký cược dài hạn",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 104,
    stt: "353",
    asset: "11. Các khoản phải trả, phải nộp khác dài hạn",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 105,
    stt: "354",
    asset: "12. Dự phòng phải trả dài hạn",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 106,
    stt: "355",
    asset: "13. Quỹ bảo vệ Nhà đầu tư",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 107,
    stt: "356",
    asset: "14. Thuế thu nhập hoãn lại phải trả",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 108,
    stt: "357",
    asset: "15. Quỹ phát triển khoa học và công nghệ",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 109,
    stt: "400",
    asset: "D. VỐN CHỦ SỞ HỮU (400=410+420)",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 110,
    stt: "410",
    asset: "I. Vốn chủ sở hữu",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 111,
    stt: "411",
    asset: "1. Vốn đầu tư của chủ sở hữu",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 112,
    stt: "411.1",
    asset: "1.1. Vốn góp của chủ sở hữu",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 113,
    stt: "411.1a",
    asset: "a. Cổ phiếu phổ thông có quyền biểu quyết",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 114,
    stt: "411.1b",
    asset: "b. Cổ phiếu ưu đãi",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 115,
    stt: "411.2",
    asset: "1.2. Thặng dư vốn cổ phần",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 116,
    stt: "411.3",
    asset: "1.3. Quyền chọn chuyển đổi trái phiếu - Cấu phần vốn",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 117,
    stt: "411.4",
    asset: "1.4. Vốn khác của chủ sở hữu",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 118,
    stt: "411.5",
    asset: "1.5. Cổ phiếu quỹ (*)",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 119,
    stt: "412",
    asset: "2. Chênh lệch đánh giá tài sản theo giá trị hợp lý",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 120,
    stt: "413",
    asset: "3. Chênh lệch tỷ giá hối đoái",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 121,
    stt: "414",
    asset: "4. Quỹ dự trữ bổ sung vốn điều lệ",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 122,
    stt: "415",
    asset: "5. Quỹ dự phòng tài chính và rủi ro nghiệp vụ",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 123,
    stt: "416",
    asset: "6. Các Quỹ khác thuộc vốn chủ sở hữu",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 124,
    stt: "417",
    asset: "7. Lợi nhuận chưa phân phối",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 125,
    stt: "417.1",
    asset: "7.1. Lợi nhuận sau thuế đã thực hiện",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 126,
    stt: "417.2",
    asset: "7.2. Lợi nhuận chưa thực hiện",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 127,
    stt: "420",
    asset: "II. Nguồn kinh phí và quỹ khác",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 128,
    stt: "440",
    asset: "TỔNG CỘNG NỢ VÀ VỐN CHỦ SỞ HỮU (440=300+400)",
    assetBold: true,
    assetCenter: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
];
const dataTableB = [
  {
    id: 0,
    stt: "",
    asset: "A. TÀI SẢN CỦA CTCK VÀ TÀI SẢN QUẢN LÝ THEO CAM KẾT",
    assetBold: true,
    assetCenter: true,
    sttBold: true,
    presentReadOnly: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: "", before: "" },
  },
  {
    id: 1,
    stt: "001",
    asset: "1. Tài sản cố định thuê ngoài",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 2,
    stt: "002",
    asset: "2. Chứng chỉ có giá nhận giữ hộ",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 3,
    stt: "003",
    asset: "3. Tài sản nhận thế chấp",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 4,
    stt: "004",
    asset: "4. Nợ khó đòi đã xử lý",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 5,
    stt: "005",
    asset: "5. Ngoại tệ các loại",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 6,
    stt: "006",
    asset: "6. Cổ phiếu đang lưu hành",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 7,
    stt: "007",
    asset: "7. Cổ phiếu quỹ",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 8,
    stt: "008",
    asset: "8. Tài sản tài chính niên yết/đăng ký giao dịch tại VSD của CTCK",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 9,
    stt: "009",
    asset: "9. Tài sản tài chính đã lưu ký tại VSD và chưa giao dịch của CTCK",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 10,
    stt: "010",
    asset: "10. Tài sản tài chính chờ về của CTCK",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 11,
    stt: "011",
    asset: "11. Tài sản tài chính sửa lỗi giao dịch của CTCK",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 12,
    stt: "012",
    asset: "12. Tài sản tài chính chưa lưu ký tại VSD của CTCK",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 13,
    stt: "013",
    asset: "13. Tài sản tài chính được hưởng quyền của CTCK",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 14,
    stt: "",
    asset: "B. TÀI SẢN VÀ CÁC KHOẢN PHẢI TRẢ VỀ TÀI SẢN QUẢN LÝ CAM KẾT VỚI KHÁCH HÀNG",
    assetBold: true,
    sttBold: true,
    presentReadOnly: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: "", before: "" },
  },
  {
    id: 15,
    stt: "021",
    asset: "1. Tài sản tài chính niêm yết/đăng ký giao dịch tại VSD của Nhà đầu tư",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 16,
    stt: "021.1",
    asset: "a. Tài sản tài chính giao dịch tự do chuyển nhượng",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 17,
    stt: "021.2",
    asset: "b. Tài sản tài chính hạn chế chuyển nhượng",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 18,
    stt: "021.3",
    asset: "c. Tài sản tài chính giao dịch cầm cố",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 19,
    stt: "021.4",
    asset: "d. Tài sản tài chính phong tỏa, tạm giữ",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 20,
    stt: "021.5",
    asset: "e. Tài sản tài chính chờ thanh toán",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 21,
    stt: "021.6",
    asset: "f. Tài sản tài chính chờ cho vay",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 22,
    stt: "022",
    asset: "2. Tài sản tài chính đã lưu ký tại VSD và chưa giao dịch của Nhà đầu tư",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 23,
    stt: "022.1",
    asset: "a. Tài sản tài chính đã lưu ký tại VSD và chưa giao dịch, tự do chuyển nhượng",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 24,
    stt: "022.2",
    asset: "b. Tài sản tài chính đã lưu ký tại VSD và chưa giao dịch, hạn chế chuyển nhượng",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 25,
    stt: "022.3",
    asset: "c. Tài sản tài chính đã lưu ký tại VSD và chưa giao dịch, cầm cố",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 26,
    stt: "022.4",
    asset: "d. Tài sản tài chính đã lưu ký tại VSD và chưa giao dịch, phong tỏa, tạm giữ",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 27,
    stt: "023",
    asset: "3. Tài sản tài chính chờ về của Nhà đầu tư",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 28,
    stt: "024.a",
    asset: "4. Tài sản tài chính sửa lỗi giao dịch của Nhà đầu tư",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 29,
    stt: "024.b",
    asset: "5. Tài sản tài chính chưa lưu ký tại VSD của Nhà đầu tư",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 30,
    stt: "025",
    asset: "6. Tài sản tài chính được hưởng quyền của Nhà đầu tư",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 31,
    stt: "026",
    asset: "7. Tiền gửi của khách hàng",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 32,
    stt: "027",
    asset: "7.1. Tiền gửi của Nhà đầu tư về giao dịch chứng khoán theo phương thức CTCK quản lý",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 33,
    stt: "028",
    asset: "7.2. Tiền gửi tổng hợp giao dịch chứng khoán cho khách hàng",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 34,
    stt: "029",
    asset: "7.3. Tiền gửi bù trừ và thanh toán giao dịch chứng khoán",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 35,
    stt: "029.1",
    asset: "a. Tiền gửi bù trừ và thanh toán giao dịch chứng khoán Nhà đầu tư trong nước",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 36,
    stt: "029.2",
    asset: "b. Tiền gửi bù trừ và thanh toán giao dịch chứng khoán Nhà đầu tư nước ngoài",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 37,
    stt: "030",
    asset: "7.4. Tiền gửi của tổ chức phát hành chứng khoán",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 38,
    stt: "031",
    asset: "8. Phải trả Nhà đầu tư về tiền gửi giao dịch chứng khoán theo phương thức CTCK quản lý",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 39,
    stt: "031.1",
    asset:
      "8.1. Phải trả Nhà đầu tư trong nước về tiền gửi giao dịch chứng khoán theo phương thức CTCK quản lý",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 40,
    stt: "031.2",
    asset:
      "8.2. Phải trả Nhà đầu tư nước ngoài về tiền gửi giao dịch chứng khoán theo phương thức CTCK quản lý",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 41,
    stt: "032",
    asset: "9. Phải trả Tổ chức phát hành chứng khoán",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 42,
    stt: "033",
    asset: "10. Phải thu của khách hàng về lỗi giao dịch các tài sản tài chính",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 43,
    stt: "034",
    asset: "11. Phải trả của khách hàng về lỗi giao dịch các tài sản tài chính",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 44,
    stt: "035",
    asset: "12. Phải trả cổ tức, gốc và lãi trái phiếu",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
];
export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);
  const [dataB, setDataB] = useState(dataTableB);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  useEffect(() => {
    setFieldValue("valuesTableB", dataB);
  }, [dataB]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(data);
  };
  const handleChangeB = (values) => {
    const { id, name, value } = values;

    setDataB((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(dataB);
  };
  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic" fontWeight="bold">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }}>Chi tiêu</Th>
              <Th style={{ textAlign: "center" }}>Mã số</Th>
              <Th style={{ textAlign: "center" }}>Thuyết minh</Th>
              <Th style={{ textAlign: "center" }}>Số cuối năm</Th>
              <Th style={{ textAlign: "center" }}>Số đầu năm</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>A</Th>
              <Th style={{ textAlign: "center" }}>B</Th>
              <Th style={{ textAlign: "center" }}>C</Th>
              <Th style={{ textAlign: "center" }}>1</Th>
              <Th style={{ textAlign: "center" }}>2</Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((rows) => (
                <tr key={rows.id}>
                  <Td
                    style={{
                      textAlign: rows.assetCenter && rows.assetCenter === true ? "center" : "left",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.assetBold === true ? "bold" : 400,
                    }}
                  >
                    {rows.asset}
                  </Td>
                  <Td
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.sttBold === true ? "bold" : 400,
                    }}
                  >
                    {rows.stt}
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.presentBold === true ? "bold" : 400,
                    }}
                  >
                    <InputTable2
                      id={rows.id}
                      name="present"
                      readOnly={rows.presentReadOnly}
                      value={rows.value.present}
                      onChange={handleChange}
                      fontWeight={rows.presentBold}
                    />
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "right",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    <InputTable
                      id={rows.id}
                      name="now"
                      readOnly={rows.readOnly}
                      value={rows.value.now}
                      onChange={handleChange}
                      fontWeight={rows.valueBold}
                    />
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "right",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    <InputTable
                      id={rows.id}
                      name="before"
                      readOnly={rows.readOnly}
                      value={rows.value.before}
                      onChange={handleChange}
                      fontWeight={rows.valueBold}
                    />
                  </Td>
                </tr>
              ))}
          </tbody>
        </table>
      </Box>
      <Box textAlign="center" marginTop="20px" marginBottom="20px">
        <Typography variant="h6" textTransform="uppercase">
          Các chỉ tiêu ngoài báo cáo tình hình tài chính riêng
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }}>Chi tiêu</Th>
              <Th style={{ textAlign: "center" }}>Mã số</Th>
              <Th style={{ textAlign: "center" }}>Thuyết minh</Th>
              <Th style={{ textAlign: "center" }}>Số cuối năm</Th>
              <Th style={{ textAlign: "center" }}>Số đầu năm</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>A</Th>
              <Th style={{ textAlign: "center" }}>B</Th>
              <Th style={{ textAlign: "center" }}>C</Th>
              <Th style={{ textAlign: "center" }}>1</Th>
              <Th style={{ textAlign: "center" }}>2</Th>
            </tr>
          </thead>
          <tbody>
            {dataB &&
              dataB.length > 0 &&
              dataB.map((rows) => (
                <tr key={rows.id}>
                  <Td
                    style={{
                      textAlign: rows.assetCenter && rows.assetCenter === true ? "center" : "left",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.assetBold === true ? "bold" : 400,
                    }}
                  >
                    {rows.asset}
                  </Td>
                  <Td
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.sttBold === true ? "bold" : 400,
                    }}
                  >
                    {rows.stt}
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.presentBold === true ? "bold" : 400,
                    }}
                  >
                    <InputTable2
                      id={rows.id}
                      name="present"
                      readOnly={rows.presentReadOnly}
                      value={rows.value.present}
                      onChange={handleChangeB}
                      fontWeight={rows.presentBold}
                    />
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "right",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    <InputTable
                      id={rows.id}
                      name="now"
                      readOnly={rows.readOnly}
                      value={rows.value.now}
                      onChange={handleChangeB}
                      fontWeight={rows.valueBold}
                    />
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "right",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    <InputTable
                      id={rows.id}
                      name="before"
                      readOnly={rows.readOnly}
                      value={rows.value.before}
                      onChange={handleChangeB}
                      fontWeight={rows.valueBold}
                    />
                  </Td>
                </tr>
              ))}
          </tbody>
        </table>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
        fontWeight: fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
function InputTable2(props) {
  const { id, onChange, type, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  const regexDecimal = /^(0|0?\.\d*|1|1(\.0*)?)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type={type == "date" ? "date" : ""}
      style={{
        textAlign: "center",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        width: type == "date" ? "150px" : "100%",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        fontWeight: fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
